import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

export type AppUpdateCopy = {
  title: string;
  description: string;
  reload: string;
};

const APP_UPDATE_COPY: Record<SupportedLocale, AppUpdateCopy> = {
  en: {
    title: 'IMAI was updated',
    description:
      'A new version is available. Reload to get the latest version.',
    reload: 'Reload',
  },
  ar: {
    title: 'تم تحديث IMAI',
    description: 'يتوفر إصدار جديد. أعد التحميل للحصول على أحدث إصدار.',
    reload: 'إعادة التحميل',
  },
  es: {
    title: 'IMAI se actualizó',
    description:
      'Hay una nueva versión disponible. Recarga para obtener la versión más reciente.',
    reload: 'Recargar',
  },
  'pt-BR': {
    title: 'O IMAI foi atualizado',
    description:
      'Uma nova versão está disponível. Recarregue para usar a versão mais recente.',
    reload: 'Recarregar',
  },
  fr: {
    title: 'IMAI a été mis à jour',
    description:
      'Une nouvelle version est disponible. Rechargez pour obtenir la dernière version.',
    reload: 'Recharger',
  },
  it: {
    title: 'IMAI è stato aggiornato',
    description:
      'È disponibile una nuova versione. Ricarica per ottenere la versione più recente.',
    reload: 'Ricarica',
  },
  ko: {
    title: 'IMAI가 업데이트되었습니다',
    description:
      '새 버전을 사용할 수 있습니다. 최신 버전을 사용하려면 새로고침하세요.',
    reload: '새로고침',
  },
  de: {
    title: 'IMAI wurde aktualisiert',
    description:
      'Eine neue Version ist verfügbar. Lade die Seite neu, um die neueste Version zu erhalten.',
    reload: 'Neu laden',
  },
  ja: {
    title: 'IMAI が更新されました',
    description:
      '新しいバージョンが利用可能です。再読み込みして最新バージョンを取得してください。',
    reload: '再読み込み',
  },
  hi: {
    title: 'IMAI अपडेट हो गया है',
    description:
      'नया संस्करण उपलब्ध है। नवीनतम संस्करण पाने के लिए पेज फिर से लोड करें।',
    reload: 'फिर से लोड करें',
  },
  ru: {
    title: 'IMAI обновлён',
    description:
      'Доступна новая версия. Перезагрузите страницу, чтобы получить последнюю версию.',
    reload: 'Перезагрузить',
  },
  zh: {
    title: 'IMAI 已更新',
    description: '有新版本可用。请重新加载以获取最新版本。',
    reload: '重新加载',
  },
  'zh-TW': {
    title: 'IMAI 已更新',
    description: '有新版本可用。請重新載入以取得最新版本。',
    reload: '重新載入',
  },
  vi: {
    title: 'IMAI đã được cập nhật',
    description: 'Đã có phiên bản mới. Tải lại để dùng phiên bản mới nhất.',
    reload: 'Tải lại',
  },
  id: {
    title: 'IMAI telah diperbarui',
    description:
      'Versi baru tersedia. Muat ulang untuk mendapatkan versi terbaru.',
    reload: 'Muat ulang',
  },
};

export function getAppUpdateCopy(
  locale: string | null | undefined
): AppUpdateCopy {
  return APP_UPDATE_COPY[normalizeLocale(locale)];
}
